import { Controller } from "@hotwired/stimulus"

import $ from "jquery"

require("../../assets/javascripts/octo_alert")

function highlight(element, color = '#ffff99') {
  const rect = element.getBoundingClientRect();
  const overlay = document.createElement('div');
  overlay.style.position = 'absolute';
  overlay.style.left = `${window.scrollX + rect.left}px`;
  overlay.style.top = `${window.scrollY + rect.top}px`;
  overlay.style.width = `${rect.width}px`;
  overlay.style.height = `${rect.height}px`;
  overlay.style.backgroundColor = color;
  overlay.style.opacity = '0.7';
  overlay.style.zIndex = '9999999';
  overlay.style.pointerEvents = 'none';
  overlay.style.transition = 'opacity 1s ease';
  document.body.appendChild(overlay);
  // Force reflow to ensure the transition triggers
  void overlay.offsetWidth;
  overlay.style.opacity = '0';
  setTimeout(() => {
    overlay.remove();
  }, 1000);
}

export default class extends Controller {
  static targets = [
    "select",
    "destroyButton"
  ]

  connect() {
    if (!this.hasSelectTarget) return;

    const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
    const bookingId = $("#bookingId").text().replace(/\s/g,'');
    const selectTarget = this.selectTarget
    const booking_chassis_id = selectTarget.id;
    let chassis_id = selectTarget.value;

    $(this.selectTarget).on("select2:select", function (e) {
      let bc_id = booking_chassis_id.replace('booking_chassis_','');
      chassis_id = selectTarget.value;

      if (chassis_id) {
        fetch(`/bookings/${bookingId}/chassis_marriages.json`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-Token': csrfToken
          },
          body: JSON.stringify({
            chassis_id: chassis_id,
            booking_chassis_id: bc_id
          })
        })
        .then(response => {
          if (!response.ok) throw response;
          return response.json();
        })
        .then(data => {
          chassis_id = document.getElementById(booking_chassis_id).value;
          document.getElementById(booking_chassis_id).parentElement.classList.add('highlight');
        })
        .catch(async error => {
          try {
            const json = await error.json();
            if (json.errors) {
              alert(json.errors);
              $(selectTarget).empty().trigger("select2:clear");
            }
          } catch (_) {}
        });
      }
    })


    $(this.destroyButtonTarget).on("click", function (e) {
      e.preventDefault();
      if (chassis_id && chassis_id != '' && booking_chassis_id) {
        fetch(`/bookings/${bookingId}/chassis_marriages/${booking_chassis_id}.json`, {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-Token': csrfToken
          },
          body: JSON.stringify({
            chassis_id: chassis_id
          })
        })
        .then(response => {
          if (!response.ok) throw response;
          $(selectTarget).empty().trigger("select2:clear");

          return response.json();
        })
        .catch(async error => {
          try {
            const json = await error.json();
            if (json.errors) {
              alert(json.errors);
            }
          } catch (_) {}
        });
      }
    })
  }
};
